import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { StateModel } from '@shared/models/common';

@Injectable()
export class StateService {
  private stateSubject: BehaviorSubject<StateModel> = new BehaviorSubject({
    loadingVisible: false,
  });
  state$: Observable<StateModel> = this.stateSubject.asObservable();

  setLoadingVisibility(value: boolean) {
    this.stateSubject.next({ loadingVisible: value });
  }
}
